module.exports = __webpack_public_path__ + "img/terms-grid.0cba3f8c.svg";